import { Md5 } from 'ts-md5'

/**
 * Repr�sente un message
 */
export class MessageModel {
    Libelle: string;
    Type: string;
    Date: Date;

    /**
     * Constructeur
     * @param libelle Libell� du message
     * @param type Type du message
     */
    constructor(libelle: string, type: string) {
        this.Libelle = libelle;
        this.Type = type;
        this.Date = new Date();
    }

    /**
     * Calcul le HASH pour cet objet
     */ 
    get Hash(): string {
        return new Md5()
            .appendStr(this.Libelle)
            .appendStr(this.Type)
            .appendStr(this.Date.toJSON())
            .end()
            .toString();
    }
}
